import React, { useContext, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ContactData from "../ContactData";
import { BasicContext } from "../../App";

const ContactModal = (props) => {
    const { onClose } = props;
    const { t } = useTranslation();
    const { setAlerts } = useContext(BasicContext);

    useEffect(() => {
        setAlerts([]);
        // eslint-disable-next-line
    }, []);

    return (
        <Modal show={true} onHide={onClose}>
            <Modal.Body>
                <ContactData />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    {t("close")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ContactModal;
